import { KyClient } from "@mittwald/api-client/dist/http/KyClient";
import { MittwaldApiV1Client } from "../MittwaldV1";
import defaultOptions from "./defaultOptions";

export const mittwaldApiV1HttpClient = new KyClient({
  ky: {
    ...defaultOptions(),
    prefixUrl: import.meta.env.VITE_APP_API_V1_URI,
  },
});

export const mittwaldApiClientV1 = new MittwaldApiV1Client(
  mittwaldApiV1HttpClient,
);
MittwaldApiV1Client.setInstance(mittwaldApiClientV1);

export default mittwaldApiClientV1;
